export enum UICustomizationSettingsDialogTabEnum {
    Group = 0,
    Device = 1,
    Well = 2,
    TankBattery = 3,
    Tank = 4,
    Tag = 5
}
